import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">精彩视频</h2>
          <p className="text-sm text-foreground-600 mt-2">精选影视片段与混剪内容，感受最精彩的视听瞬间</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <article key={item.id} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden aspect-video mb-3 bg-background-200">
                <img
                  src={item.image}
                  alt={`91视频 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/35 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">
                {item.title}
              </h3>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-eye-line"></i>
                <span>{item.views} 次观看</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}